<template>
    <v-dialog
    	v-model="localValue"
    	:max-width="maxWidth"
		content-class="rounded-medium"
    	:persistent="persistent"
    >
		<v-card>
			<v-card-title v-if="title" class="pb-0">
				{{title}}
			</v-card-title>
			<v-card-subtitle v-if="subtitle" class="font-weight-bold black--text pb-0" :class="{ 'mt-0': title }">
				{{subtitle}}
			</v-card-subtitle>
			<div class="progress-container ms-6 me-auto mt-3 mb-4">
				<v-progress-linear v-if="loading" absolute height="2" rounded indeterminate/>
				<v-divider/>
			</div>
			<v-card-text class="pb-0">
				<template v-if="message">{{message}}</template>
				<slot v-if="$slots.message || $scopedSlots.message" name="message"/>
				<slot v-else/>
			</v-card-text>
			<v-card-actions>
				<v-btn
					color="success"
					text
					:disabled="disableConfirm"
					:loading="loadingConfirm"
					@click="$emit('handler'); $emit('close'); $emit('click:confirm')"
				>
					{{confirmBtnContent ? confirmBtnContent : $t('buttons.ok')}}    
				</v-btn>
				<v-btn
					v-if="optionBtnContent"
					color="alert-color"
					text
					:disabled="disableOption"
					:loading="loadingOption"
					@click="$emit('click:option')"
				>
					{{optionBtnContent}}
				</v-btn>
				<v-btn
					color="danger-color"
					text
					@click="$emit('close'); $emit('click:close')"
				>
					{{$t('buttons.cancel')}}
				</v-btn>
				<v-spacer></v-spacer>

				<slot name="actions-append"></slot>
			</v-card-actions>
		</v-card>
    </v-dialog>
</template>
<script>
export default {
	name: "BeeDialog", 
	props: {
		value: { type: Boolean },
		title: { type: String },
		maxWidth: { type: [String, Number], default: 500 },
		message: { type: String },
		persistent: { type: Boolean },
		subtitle: { type: String },
		loading: { type: Boolean },
		
		confirmBtnContent: { type: String },
		disableConfirm: { type: Boolean },
		loadingConfirm: { type: Boolean },

		optionBtnContent: { type: String },
		disableOption: { type: Boolean },
		loadingOption: { type: Boolean },
	},
	computed: {
		localValue: {
			get: function () {
				return this.value
			},
			set: function (value) {
				this.$emit('input', value)
			}
		}  
	}
}
</script>
<style lang="scss">
.progress-container {
	position: relative;
	max-width: 350px;
	width: 80%;
}
</style>